import React from 'react';
import { motion } from 'framer-motion';
export function OwnerServices() {
  return <div className="pt-32 pb-24 min-h-screen bg-charcoal-900 text-white" data-id="element-300">
      <div className="max-w-7xl mx-auto px-6" data-id="element-301">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="max-w-3xl mb-16" data-id="element-302">
          <h1 className="text-5xl font-serif mb-6" data-id="element-303">Owner Services</h1>
          <p className="text-xl text-gray-300" data-id="element-304">
            Comprehensive aircraft management solutions designed to protect your
            asset and maximize your investment.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-305">
          <div className="space-y-8" data-id="element-306">
            {[{
            title: 'Turnkey Management',
            desc: 'We handle crew hiring, maintenance scheduling, and regulatory compliance.'
          }, {
            title: 'Charter Revenue',
            desc: 'Offset your ownership costs by adding your aircraft to our charter certificate.'
          }, {
            title: 'Financial Reporting',
            desc: 'Transparent, detailed monthly statements of all aircraft activities and expenses.'
          }].map((service, i) => <motion.div key={service.title} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1
          }} className="p-6 rounded-2xl bg-white/5 border border-white/10" data-id="element-307">
                <h3 className="text-xl font-semibold text-brand-400 mb-2" data-id="element-308">
                  {service.title}
                </h3>
                <p className="text-gray-400" data-id="element-309">{service.desc}</p>
              </motion.div>)}
          </div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="rounded-2xl overflow-hidden" data-id="element-310">
            <img src="https://images.unsplash.com/photo-1629196914212-0168ce02f436?q=80&w=1200&auto=format&fit=crop" alt="Aircraft Maintenance" className="w-full h-full object-cover" data-id="element-311" />
          </motion.div>
        </div>
      </div>
    </div>;
}